import React, { useEffect } from 'react';
import { styled, colors } from '~/styles';
import backgroundImg from '~/assets/images/marble-background-large.jpg';
import { PageContainer } from '~/components/layout/PageBasics';

const StyledPageContainer = styled(PageContainer)`
  display: flex;
  justify-content: center;
  align-items: center;

  .loading-container {
    .loading-img {
      margin-bottom: 57px;
      transform: translateY(32%); // svg padding compensation
    }
    .loading-text {
      text-transform: uppercase;
      font-size: 20px;
      font-weight: bold;
    }
  }
`

const LoginPage = () => {
  useEffect(() => {
    window.location.href = 'https://revanceu.com/';
  }, []);

  return(
    <StyledPageContainer bgImage={backgroundImg}>
      <div className='loading-container'>
        <p className='loading-text'>Redirecting to login...</p>
      </div>
    </StyledPageContainer>
  )
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/pages/login/index.tsx